import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Button,
} from 'reactstrap';
import styled from 'styled-components';
import Logo from '../assets/logo.png'; // Assuming the logo is now an SVG.

const CustomNavbar = ({ colorV, navC, pos }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <Container fluid className="px-0" style={{ background: colorV }}>
      <Navbar color={navC} className="px-0 mt-2 mx-3 px-md-5 pt-md-4 head" light fixed={pos} expand="md">
        <CustomBrand
          className="no-decoration font-weight-bold h3 mb-0 d-flex align-items-center justify-content-center"
          to="/"
        >
          <img src={Logo} alt="Logo" width={60} /> XPLOREUX
        </CustomBrand>
        <NavbarToggler className="no-btn-shadow border-0" onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="nav-right ml-auto" navbar>
            <NavItem>
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle
                  tag="div"
                  className="dropdown-link no-decoration text-grey my-4 ml-3 ml-md-0 my-md-0 mr-md-5 pr-md-4"
                  style={{ cursor: 'pointer' }}
                >
                  Product
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem header>
                    <i className="ico-phone-1" /> Usability Testing
                    <span className="text-muted">Test apps and websites</span>
                  </DropdownItem>
                  <DropdownItem>
                    <i className="ico-camera" /> Interview
                    <span className="text-muted">Talk to your customers</span>
                  </DropdownItem>
                  <DropdownItem>
                    <i className="eureka-icon-svg" /> Eureka
                    <span className="text-muted">Your research sidekick</span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </NavItem>
            <NavItem>
              <Link
                className="no-decoration text-grey my-4 ml-3 ml-md-0 my-md-0 mr-md-5 pr-md-4"
                to="/price"
              >
                Price
              </Link>
            </NavItem>
            <NavItem>
              <Link
                className="no-decoration text-grey my-4 ml-3 ml-md-0 my-md-0 mr-md-5 pr-md-4"
                to="/help"
              >
                Help
              </Link>
            </NavItem>
            <NavItem>
              <Link className="no-decoration ml-3 ml-md-0" to="/login">
                Login
              </Link>
            </NavItem>
            <NavItem>
              <Button
                className="no-decoration ml-3 ml-md-0 border-color-blue border-2"
                color="primary"
                to="/signup"
              >
                Try 5 Sessions Free
              </Button>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </Container>
  );
};

const CustomBrand = styled(Link)`
  font-family: 'Nunito', sans-serif;
  color: #5d2cff;
`;

// Add custom CSS for "nav-right" class to move items to the right
const customStyles = `
  .nav-right {
    margin-left: auto !important;  /* Force alignment to right */
  }
  .dropdown-link:hover {
    color: #000;
  }
  .dropdown-menu span.text-muted {
    display: block;
    font-size: 12px;
    margin-left: 20px;
  }
`;
document.head.insertAdjacentHTML('beforeend', `<style>${customStyles}</style>`);

export default CustomNavbar;
